import { i as copy_payload, j as assign_payload, p as pop, a as push, h as head, e as escape_html, k as ensure_array_like, b as attr, n as maybe_selected } from "../../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../../chunks/exports.js";
import "../../../../../chunks/utils.js";
import "../../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../../chunks/Toast.svelte.js";
import "../../../../../chunks/validationSchemas.js";
import { M as Modal } from "../../../../../chunks/Modal.js";
function _page($$payload, $$props) {
  push();
  const { data, form } = $$props;
  getToastState();
  let product = data.product || null;
  let categories = data?.categories || [];
  let name = data.product?.name;
  let description = data.product?.description;
  let price = data.product?.price;
  let digitalCopyPrice = data.product?.digitalCopyPrice;
  let quantity = data.product?.quantity;
  data.product?.serviceCode;
  let author = data.product?.author;
  let citation = data.product?.citation || "";
  let isbn = data.product?.ISBN || "";
  let publicationDateISO = data.product?.publicationDate;
  let pageCount = data.product?.pageCount;
  let imageUrl = data.product?.Image[0]?.url;
  let showDeleteModal = false;
  let showPublishModal = false;
  let selectedCategories = data.product?.categories || [];
  console.log("Product data:", data.product);
  let publicationDate = publicationDateISO ? new Date(publicationDateISO).getFullYear().toString() : "";
  const allowedExtensions = [".jpg", ".jpeg", ".png", ".webp"];
  let existingDocuments = data.productDocuments || [];
  let formErrors = {};
  const getFieldError = (field) => formErrors[field]?.[0] || "";
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    head($$payload2, ($$payload3) => {
      $$payload3.title = `<title>${escape_html(name)} Details</title>`;
    });
    $$payload2.out.push(`<div class="container mx-auto p-6">`);
    if (!product) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<p class="text-center text-sm font-black text-gray-500">Product not found</p>`);
    } else {
      $$payload2.out.push("<!--[!-->");
      const each_array = ensure_array_like(categories);
      $$payload2.out.push(`<div class="mb-6 flex items-center gap-4"><img${attr("src", imageUrl || "/coat-of-arms.jpg")} alt="product" class="bg-primary h-32 w-32 rounded-sm object-cover shadow-xs"/> <div><h1 class="text-2xl font-bold">${escape_html(name)}</h1> <p class="text-gray-600">${escape_html(description)}</p></div></div> `);
      Modal($$payload2, {
        title: "Delete Book",
        get show() {
          return showDeleteModal;
        },
        set show($$value) {
          showDeleteModal = $$value;
          $$settled = false;
        },
        children: ($$payload3) => {
          $$payload3.out.push(`<p class="mb-6 text-gray-600">Are you sure you want to delete "${escape_html(name)}"? This action cannot be undone.</p> <div class="flex justify-end gap-4"><button class="rounded-md bg-gray-100 px-4 py-2 text-gray-600 transition-colors hover:bg-gray-200">Cancel</button> <button class="rounded-md bg-red-500 px-4 py-2 text-white transition-colors hover:bg-red-600">Delete</button></div>`);
        },
        $$slots: { default: true }
      });
      $$payload2.out.push(`<!----> `);
      Modal($$payload2, {
        title: `${data.product?.isPublished ? "Unpublish" : "Publish"} Book`,
        get show() {
          return showPublishModal;
        },
        set show($$value) {
          showPublishModal = $$value;
          $$settled = false;
        },
        children: ($$payload3) => {
          $$payload3.out.push(`<p class="mb-6 text-gray-600">Are you sure you want to ${escape_html(data.product?.isPublished ? "unpublish" : "publish")} "${escape_html(name)}"?</p> <div class="flex justify-end gap-4"><button class="rounded-md bg-gray-100 px-4 py-2 text-gray-600 transition-colors hover:bg-gray-200">Cancel</button> <button class="bg-secondary hover:bg-secondary/90 flex w-36 justify-center rounded-md px-4 py-2 text-white transition-colors">${escape_html(data.product?.isPublished ? "Unpublish" : "Publish")}</button></div>`);
        },
        $$slots: { default: true }
      });
      $$payload2.out.push(`<!----> <div class="mb-6 flex items-center gap-4"><a href="/admin/product" class="flex items-center gap-2 rounded-md bg-gray-100 px-4 py-2 text-gray-600 transition-colors hover:bg-gray-200">← Back to Products</a></div> <div class="grid gap-6 lg:grid-cols-3"><div class="lg:col-span-2"><div class="rounded-lg border border-gray-200 bg-white"><div class="border-b p-6"><div class="flex items-center justify-between"><h1 class="text-2xl font-bold">${escape_html(name)}</h1></div></div> <div class="p-6"><form method="POST" enctype="multipart/form-data" class="space-y-6">`);
      if (formErrors._errors) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<div class="rounded-md bg-red-50 p-3 text-sm text-red-500">${escape_html(formErrors._errors[0])}</div>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--> <div class="space-y-4"><div><label for="name" class="text-sm font-medium text-gray-700">Book Title</label> <input id="name" type="text" name="name"${attr("value", name)}${attr("aria-invalid", !!getFieldError("name"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="e.g., The Constitution of Kenya"/> `);
      if (getFieldError("name")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("name"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div class="grid gap-4 sm:grid-cols-2"><div><label for="price" class="text-sm font-medium text-gray-700">Price (KES)</label> <input id="price" type="number" name="price"${attr("value", price)} min="0"${attr("aria-invalid", !!getFieldError("price"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="1500"/> `);
      if (getFieldError("price")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("price"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div><label for="digitalCopyPrice" class="text-sm font-medium text-gray-700">Digital Copy Price (KES)</label> <input id="digitalCopyPrice" type="number" name="digitalCopyPrice"${attr("value", digitalCopyPrice)} min="0"${attr("aria-invalid", !!getFieldError("digitalCopyPrice"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="500"/> `);
      if (getFieldError("digitalCopyPrice")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("digitalCopyPrice"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div><label for="quantity" class="text-sm font-medium text-gray-700">Quantity in Stock</label> <input id="quantity" type="number" name="quantity"${attr("value", quantity)} min="0"${attr("aria-invalid", !!getFieldError("quantity"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="e.g., 100"/> `);
      if (getFieldError("quantity")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("quantity"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div><label for="author" class="text-sm font-medium text-gray-700">Author</label> <input id="author" type="text" name="author"${attr("value", author)}${attr("aria-invalid", !!getFieldError("author"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="National Council for Law Reporting (Kenya Law)."/> `);
      if (getFieldError("author")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("author"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div><label for="citation" class="text-sm font-medium text-gray-700">Citation <span class="text-gray-500">(optional)</span></label> <input id="citation" type="text" name="citation"${attr("value", citation)}${attr("aria-invalid", !!getFieldError("citation"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden"/> `);
      if (getFieldError("citation")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("citation"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div><label for="isbn" class="text-sm font-medium text-gray-700">ISBN <span class="text-gray-500">(optional)</span></label> <input id="isbn" type="text" name="isbn"${attr("value", isbn)}${attr("aria-invalid", !!getFieldError("isbn"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="978-0-123456-78-9"/> `);
      if (getFieldError("isbn")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("isbn"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div><label for="publicationDate" class="text-sm font-medium text-gray-700">Publication Year</label> <input id="publicationDate" type="number" name="publicationDate"${attr("value", publicationDate)}${attr("aria-invalid", !!getFieldError("publicationDate"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="e.g., 2024" min="1900"${attr("max", (/* @__PURE__ */ new Date()).getFullYear() + 5)}/> `);
      if (getFieldError("publicationDate")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("publicationDate"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div>  <div class="mb-4 space-y-2"><label for="categories" class="text-sm font-medium text-gray-700">Select Categories</label> <select name="categoryIds" class="focus:border-primary focus:ring-primary w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-none"><option value=""${maybe_selected($$payload2, "")}>--</option><!--[-->`);
      for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
        let category = each_array[$$index];
        if (!selectedCategories.find((c) => c.id === category.id)) {
          $$payload2.out.push("<!--[-->");
          $$payload2.out.push(`<option${attr("value", category.id)}${maybe_selected($$payload2, category.id)}>${escape_html(category.name)}</option>`);
        } else {
          $$payload2.out.push("<!--[!-->");
        }
        $$payload2.out.push(`<!--]-->`);
      }
      $$payload2.out.push(`<!--]--></select> `);
      if (getFieldError("categoryIds")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("categoryIds"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--> <div class="flex flex-wrap gap-2">`);
      if (selectedCategories.length === 0) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="text-sm text-gray-500">No categories selected</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
        const each_array_1 = ensure_array_like(selectedCategories);
        $$payload2.out.push(`<!--[-->`);
        for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
          let category = each_array_1[$$index_1];
          $$payload2.out.push(`<div class="flex items-center gap-2 rounded-md bg-gray-100 px-3 py-1"><span class="text-sm">${escape_html(category.name)}</span> <button type="button" class="text-gray-500 hover:text-gray-700">x</button></div>`);
        }
        $$payload2.out.push(`<!--]-->`);
      }
      $$payload2.out.push(`<!--]--></div></div> <div><label for="pageCount" class="text-sm font-medium text-gray-700">Page Count</label> <input id="pageCount" type="number" name="pageCount"${attr("value", pageCount)}${attr("aria-invalid", !!getFieldError("pageCount"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="e.g., 250"/> `);
      if (getFieldError("pageCount")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("pageCount"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div><label for="description" class="text-sm font-medium text-gray-700">Description</label> <textarea id="description" name="description" rows="3"${attr("aria-invalid", !!getFieldError("description"))} class="focus:border-primary focus:ring-primary mt-1 w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden" placeholder="Enter a detailed description of the book, including key topics, target audience, and any special features...">`);
      const $$body = escape_html(description);
      if ($$body) {
        $$payload2.out.push(`${$$body}`);
      }
      $$payload2.out.push(`</textarea> `);
      if (getFieldError("description")) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("description"))}</p>`);
      } else {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--></div> <div class="mb-4"><label for="newImage" class="text-sm font-medium text-gray-700">Upload New Image</label> <input id="newImage" type="file" name="newImage"${attr("accept", allowedExtensions.join(","))} class="mt-1 w-full rounded-md border p-2"/></div></div> <div class="flex justify-end gap-4"><div><button type="button" class="bg-secondary hover:bg-secondary/90 flex w-36 justify-center rounded-md px-4 py-2 text-white transition-colors">${escape_html(data.product?.isPublished ? "Unpublish" : "Publish")}</button></div> <button type="submit" class="bg-primary hover:bg-primary/90 flex w-36 justify-center rounded-md px-4 py-2 text-white transition-colors">`);
      {
        $$payload2.out.push("<!--[!-->");
      }
      $$payload2.out.push(`<!--]--> Save</button> <button type="button" class="flex w-36 justify-center rounded-md bg-red-600 px-4 py-2 text-white transition-colors hover:bg-red-600/90">Delete</button></div></div></form></div></div></div> <div class="space-y-6"><div class="rounded-lg border border-gray-200 bg-white p-6"><h2 class="mb-4 text-lg font-semibold">PDF Documents</h2> <p class="mb-4 text-xs text-gray-500">Attach supplementary PDF documents (max 25MB each). Existing uploads can be replaced by uploading a
						file with the same original filename.</p> <div class="space-y-3"><div class="space-y-2"><label for="pdfUpload" class="text-sm font-medium text-gray-700">Upload PDFs</label> <input id="pdfUpload" type="file" multiple accept="application/pdf" class="w-full cursor-pointer rounded-md border border-dashed border-gray-300 p-2 text-sm hover:border-gray-400"/> <p class="text-xs text-gray-500">Select one or more PDF files to upload or replace.</p></div> <ul class="divide-y rounded-md border border-gray-200 bg-white text-sm">`);
      if (existingDocuments.length === 0) {
        $$payload2.out.push("<!--[-->");
        $$payload2.out.push(`<li class="p-3 text-gray-500">No documents uploaded yet</li>`);
      } else {
        $$payload2.out.push("<!--[!-->");
        const each_array_2 = ensure_array_like(existingDocuments);
        $$payload2.out.push(`<!--[-->`);
        for (let $$index_2 = 0, $$length = each_array_2.length; $$index_2 < $$length; $$index_2++) {
          let doc = each_array_2[$$index_2];
          $$payload2.out.push(`<li class="flex items-center justify-between gap-2 p-3"><span class="truncate"${attr("title", doc.originalName)}>${escape_html(doc.originalName)}</span> <button type="button" class="text-xs text-red-600 hover:underline">Delete</button></li>`);
        }
        $$payload2.out.push(`<!--]-->`);
      }
      $$payload2.out.push(`<!--]--></ul></div></div></div></div>`);
    }
    $$payload2.out.push(`<!--]--></div>`);
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
